import { SET_LOCATION } from '../actions/types';

export default function location(state = null, action) {
	if (!action.error && action.payload && action.type === SET_LOCATION) {
		return action.payload;
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/location.js